import { transformTimeSlot } from "@/features/calendar/utils/appointmentPickerUtils";

import { TIME_SLOT_OPTIONS } from "../constants";

type TimeSlotOption = { label: string; value: string };

// session_from/session_to can be backend-prefilled with an exact time (e.g.
// call start/end) that doesn't land on the 5-min grid in TIME_SLOT_OPTIONS.
// The schema accepts any valid HH:mm (see AdvancedCareActivity.schema.js),
// so the picker needs to also offer that exact value — otherwise FormSelect
// can't find a matching option and renders blank despite a valid stored
// value. The injected option's label is marked "(exact)" so it reads as
// distinct from the regular 5-min grid entries in both the closed field and
// the open menu.
export const getTimeSlotOptionsWithValue = (value: Nullable<string>) => {
  if (!value || TIME_SLOT_OPTIONS.some((option: TimeSlotOption) => option.value === value)) {
    return TIME_SLOT_OPTIONS;
  }

  const exactSlot = transformTimeSlot(value);

  return [...TIME_SLOT_OPTIONS, { ...exactSlot, label: `${exactSlot.label} (exact)` }].sort(
    (a: TimeSlotOption, b: TimeSlotOption) => a.value.localeCompare(b.value),
  );
};
